import {useEffect, useState} from "react";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {GET_ALL_PRENOTAZIONI_URL,} from "../../../../services/utils/ApiUrls";

export default function useGetAllPrenotazioni(stato, pageNumber, value, sort, dir, open, search, priority, active, critEpidem, contattoRich, luogo) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [prenotazioni, setPrenotazioni] = useState([]);
    const [hasMore, setHasMore] = useState(false);


    const encodeStato = (stato) => {
        console.log(stato);
        switch (stato) {
            case "Odierni" :
                return "TODAY";
            case "Da confermare" :
                return "APPROVAL";
            case "Conclusi" :
                return "DONE";
            case "Annullati" :
                return "DELETED";
            case "Tutti" :
                return undefined;
        }
    }

    function getData(stato, val, src, priorty, active, critEpidem, cr, luogoPrenot) {

        let data = {
            id: src.id ? src.id : null,
            stato: encodeStato(stato),
            active: active,
            motivazione: priorty === "Normale" ? null : priorty,
            contattoRichiedente: cr,
            luogo: luogoPrenot,
            criterioEpidemiologico: critEpidem !== "" ? critEpidem : null,
        }
        if (src.codF || src.cell || src.nome || src.cognome) {
            data = {
                ...data,
                active: active,
                contattoRichiedente: cr,
                luogo: luogoPrenot,
                soggetto: {
                    codF: src.codF,
                    nome: src.nome ? src.nome : null,
                    cognome: src.cognome ? src.cognome : null,
                    cell: src.cell ? src.cell : null,
                }
            }
        }
        if (src.dataRichiesta) {
            let dataRich = new Date(src.dataRichiesta);
            dataRich.setHours(0);
            dataRich.setMinutes(0);
            dataRich.setSeconds(0);
            dataRich.setMilliseconds(0);
            data = {
                ...data,
                active: active,
                dataRichiesta: dataRich,
            }
        }
        if (src.dataInserimento) {
            let dataIns = src.dataRichiesta;
            dataIns.setHours(0);
            dataIns.setMinutes(0);
            dataIns.setSeconds(0);
            dataIns.setMilliseconds(0);
            data = {
                ...data,
                active: active,
                dataInserimento: dataIns,
            }
        }
        if (src.dataEffettiva) {
            let dataEff = src.dataEffettiva;
            dataEff.setHours(0);
            dataEff.setMinutes(0);
            dataEff.setSeconds(0);
            dataEff.setMilliseconds(0);
            data = {
                ...data,
                active: active,
                dataEffettiva: dataEff,
            }
        }
        if (src.id) {
            data = {
                ...data,
                id: src.id
            }
        }

        return data;

    }

    // function getUrl(pNum, s, d) {
    //     // return GET_ALL_PRENOTAZIONI_URL + pNum + "/" + s + "/" + d;
    //     return GET_ALL_PRENOTAZIONI_URL;
    // }

    function getUrl(stato, tipo) {
        let url = GET_ALL_PRENOTAZIONI_URL;
        let params = new URLSearchParams();

        if (stato !== undefined) {
            params.append("stato", stato);
        }
        if (tipo !== undefined) {
            params.append("tipo", tipo);
        }

        if (params.toString()) {
            url += "?" + params.toString();
        }

        return url;
    }


    useEffect(() => {
        setPrenotazioni([]);
    }, [stato, sort, dir, search, value, priority, active, critEpidem, contattoRich, luogo])

    useEffect(() => {
        if (stato !== "Crea agenda" && stato !== "Visualizza agende") {
            setLoading(true);
            setError(false);

            axios({
                method: "GET",
                url: getUrl(encodeStato(stato), luogo),
                // data: getData(stato, value, search, priority, active, critEpidem, contattoRich, luogo),
                ...getConfig(),
            }).then(response => {
                setPrenotazioni(prevState => {
                    let newState = [...prevState, ...response.data];
                    return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
                })
                // setHasMore(response.data.length > 0);
                setHasMore(false);
                setLoading(false);
            })
                .catch(() => {
                    setError(true);
                    setLoading(false);
                })
        }
    }, [stato, pageNumber, value, sort, dir, search, priority, active, critEpidem, contattoRich, luogo])

    return {loading, error, prenotazioni, hasMore};
}
